<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
  
  }
}
</script>
<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
ul li{
  list-style: none;
}
.ivu-modal-header{
    // padding:0px !important;
}
input:focus {
outline:none;
}
.ivu-modal-body{
  // padding:0px;
}
.ivu-table th{
  background-color: #fff;
}
.ivu-btn-primary{
  background-color: #0198CD;
  border-color: #0198CD;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover {
    border-right: none;
    color: #fff;
    background: #0198CD!important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu){
    border-right: none;
    color: #fff;
    background: #0198CD!important;
}
  .hr{
        height: 2px;
        width: 100%;
        background-color: #DAE1E8;
    }
    .ivu-layout-header{
        padding:0;
    }
    .ivu-form-item-label{
      font-weight: bold;
    }
    .ivu-btn-success{
      background-color: #2EB135;
      border-color: #2EB135;
    }
    .ivu-radio-inner:after{
      background-color: #000;
    }
    .ivu-radio-checked .ivu-radio-inner{
      border-color: #000;
    }
    .ivu-radio-wrapper{
      font-weight: bold;
    }
    .ivu-select-selection{
      border-radius: 0%;
    }
    .ivu-input{
       border-radius: 0%;
    }
      .ivu-table .demo-table-info-row td{
        background-color: #EAFCFF;
        color: #435265;
    }
   
.tab .ivu-table td{
  border:none;

}
.tab .ivu-table th{
    border-bottom:2px solid #5FD7FE;
}  
.tab .ivu-table:before{
  background-color: #fff;
}
.ivu-select-prefix{
    width: 30px;
    height: 30px;
    background-color: #D9F5FF;
    text-align: center;
    padding-left: 0px!important;
    img{
      margin-top: 4px;
    }
}

// 
.ivu-page-item-jump-next, .ivu-page-item-jump-prev, .ivu-page-next, .ivu-page-prev{
    border-radius: none!important;
    border-color:#00BFFF;
}
.ivu-page-next, .ivu-page-prev {
    background-color: #EAFCFF;
    color: #00BFFF;
      a{
        color: #0198CD;
      }
}
.ivu-page-next:hover a, .ivu-page-prev:hover a {
     color: #0198CD;
}
.ivu-page-item{
  background-color:#EAFCFF;
   border-color:#00BFFF;
  border-radius: none!important;
  a{
color: #00BFFF;
  }
}
.ivu-page-item-active {
     background-color:#0198CD;
     border-color:#0082AC;
     color:#fff;
     a{
       color: #fff;
     }
}
.ivu-page-item-active:hover a {
    color: #fff;
}
.area-select .area-selected-trigger{
                    line-height: 17px!important;
                }
                .area-select-wrap .area-select{
                  margin-left:0px!important;
                }
                .tab .area-select.medium {
                  width: 100px;
              }
              .area-select.medium{
                width: 156px!important;
              }
</style>



// WEBPACK FOOTER //
// src/App.vue